<template>
  <DashboardOverview v-if="$PickoVersion.isV2()" />
  <DashboardDefault v-else />
</template>

<script>
import DashboardDefault from "./Default.vue";
import DashboardOverview from "./overview/DashboardOverview.vue";

// The new dashboard reads v2-only endpoints; v1 customers keep the previous
// one until they migrate.
export default {
  name: "DashboardByVersion",
  components: { DashboardDefault, DashboardOverview },
};
</script>
